import React from "react";
import { useTranslate } from "react-admin";
import { Box, Typography } from "@material-ui/core";
import { PalletBaseCard } from "../shared/PalletBaseCard";

export const MovementPalletCard = ({ pallet, classes }) => {
	const translate = useTranslate();

	const extraRows = (
		<React.Fragment>
			<Box className={classes.palletRow}>
				<Typography className={classes.palletLabel}>
					{translate("resources.storage-transactions.fields.from_place")}
				</Typography>
				<Typography className={classes.palletValue}>{pallet.from_place_address || "-"}</Typography>
			</Box>
			<Box className={classes.palletRow}>
				<Typography className={classes.palletLabel}>
					{translate("resources.storage-transactions.fields.to_place")}
				</Typography>
				<Typography className={classes.palletValue}>{pallet.to_place_address || "-"}</Typography>
			</Box>
		</React.Fragment>
	);

	return <PalletBaseCard pallet={pallet} classes={classes} cardClassName={classes.palletCardMoved} extraRows={extraRows} />;
};
